import { Minicart } from '../../../../vtex-apps/minicart/Minicart/default';
import { MinicartBaseContent } from '../../../../vtex-apps/minicart/MinicartBaseContent/default';
import { v4 as uuidv4 } from 'uuid';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DrawerCloseButton } from '../../../../vtex-apps/store-drawer/DrawerCloseButton/default';
import { MinicartProductList } from '../../../../vtex-apps/minicart/MinicartProductList/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductList } from '../../../../vtex-apps/minicart-product-list/ProductList/default';
import { MinicartProductListContentMobile } from '../../../../vtex-apps/minicart-product-list/MinicartProductListContentMobile/default';
import { MinicartSummary } from '../../../../vtex-apps/minicart/MinicartSummary/default';
import { MinicartEmptyState } from '../../../../vtex-apps/minicart/MinicartEmptyState/default';
import { CheckoutSummaryTotalizers } from '../../../../vtex-apps/checkout-summary/CheckoutSummaryTotalizers/default';
import { CheckoutSummaryCompact } from '../../../../vtex-apps/checkout-summary/CheckoutSummaryCompact/default';
import { MinicartProductListImage } from '../../../../vtex-apps/minicart-product-list/MinicartProductListImage/default';
// import { MinicartBar } from "../../../../vtex-apps/vtexeurope/MinicartBar/default";
import { MinicartProductListPrice } from '../../../../vtex-apps/minicart-product-list/MinicartProductListPrice/default';
import { MinicartCheckoutButton } from '../../../../vtex-apps/minicart/MinicartCheckoutButton/default';
import { MinicartProductListRemoveButton } from '../../../../vtex-apps/minicart-product-list/MinicartProductListRemoveButton/default';
import { MinicartProductListQuantitySelector } from '../../../../vtex-apps/minicart-product-list/MinicartProductListQuantitySelector/default';
import { MinicartProductListProductVariations } from '../../../../vtex-apps/minicart-product-list/MinicartProductListProductVariations/default';
import { MinicartProductListProductName } from '../../../../vtex-apps/minicart-product-list/MinicartProductListProductName/default';
import { IconCart } from '../../../../vtex-apps/icons/default';

const MinicartGroup = () => {
	return {
		//    "minicart.v2#main-header"
		componentName: 'MinicartFixed',
		componentId: uuidv4(),
		componentGroup: 'MinicartGroup',
		variables,
		props: Minicart({ blockClass: 'mz-cart' }).props,
		childrenComponents: [
			MinicartBaseContent(
				{},
				[
					MinicartProductList(
						{
							blockClass: 'mz-cart__minicart-product-list',
						},
						[],
						[
							ProductList(
								{},
								[],
								[
									MinicartProductListContentMobile({}, [
										FlexLayoutRow(
											{
												fullWidth: true,
												paddingBottom: 6,
												paddingTop: 5,
												colSizing: 'auto',
												preserveLayoutOnMobile: true,
												blockClass: 'mz-cart',
											},
											[
												FlexLayoutCol(
													{
														marginRight: 5,
													},
													[
														MinicartProductListImage({
															width: 80,
														}),
													],
												),
												FlexLayoutCol({ width: 'grow', blockClass: 'mz-cart__details-col' }, [
													FlexLayoutRow(
														{
															colSizing: 'auto',
															preserveLayoutOnMobile: true,
															horizontalAlign: 'between',
														},
														[
															MinicartProductListProductName({ blockClass: 'mz-cart' }),
															MinicartProductListRemoveButton({ blockClass: 'mz-cart' }),
														],
													),
													FlexLayoutRow({ width: '100%' }, [
														MinicartProductListProductVariations({ blockClass: 'mz-cart' }),
													]),
													FlexLayoutRow(
														{
															preserveLayoutOnMobile: true,
															blockClass: 'mz-cart__price-row',
															horizontalAlign: 'between',
														},
														[
															FlexLayoutCol(
																{
																	colSizing: 'auto',
																	preserveLayoutOnMobile: true,
																},
																[MinicartProductListPrice({ blockClass: 'mz-cart' })],
															),
															MinicartProductListQuantitySelector({
																blockClass: 'mz-cart',
																mode: 'stepper',
															}),
														],
													),
												]),
											],
										),
									]),
								],
							),
						],
					),
					FlexLayoutRow({ blockClass: 'minicart-footer' }, [
						FlexLayoutCol({}, [
							// RichText({
							//     text: "[Cadastre-se](/account#/profile) e **GANHE 10% OFF** na primeira compra",
							//     fullWidth: true,
							//     blockClass: "minicart-sale-text"
							// }),
							MinicartSummary(
								{ blockClass: 'mz-cart' },
								[],
								[
									CheckoutSummaryCompact(
										{
											totalizersToShow: ['Items', 'Discounts'],
											blockClass: 'mz-cart',
										},
										[
											CheckoutSummaryTotalizers({
												showTotal: true,
												showDeliveryTotal: true,
												blockClass: 'mz-cart',
											}),
										],
									),
								],
							),
							//freeshipping
							// MinicartBar({ blockClass: "mz-cart" }),
							MinicartCheckoutButton({ blockClass: 'mz-cart' }),
							DrawerCloseButton({ blockClass: 'continuar-comprando', text: 'Continuar Comprando' }),
						]),
					]),
				],
				[
					MinicartEmptyState({}, [
						FlexLayoutRow({}, [
							FlexLayoutCol(
								{
									horizontalAlign: 'center',
									verticalAlign: 'middle',
									rowGap: 5,
								},
								[
									IconCart({ size: 64, blockClass: 'minicart-empty-state' }),
									RichText({ text: 'Seu carrinho está vazio. :(' }),
								],
							),
						]),
					]),
				],
			),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--brand-color-primary-pure', to: '--minicart-2-header-text-color', name: 'Header Text' },
			{ from: '--white', to: '--minicart-2-header-color', name: 'Header' },
			{ from: '--black', to: '--minicart-2-close-color', name: 'Close Icon' },
			{ from: '--black', to: '--minicart-2-delete-color', name: 'Delete Icon' },
			{ from: '--text-color-1', to: '--minicart-2-product-name-color', name: 'Product Name' },
			{ from: '--text-color-1', to: '--minicart-2-variation-color', name: 'Variation Text' },
			{ from: '--text-color-1', to: '--minicart-2-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--minicart-2-price-color', name: 'Price' },
			{ from: '--text-color-1', to: '--minicart-2-quantity-detail-color', name: 'Product Quantity Detail' },
			{ from: '--text-color-1', to: '--minicart-2-quantity-border-color', name: 'Product Quantity Border' },
			// {from:"--brand-color-primary-dark",to:"--minicart-2-sale-bg-color",name:"Sale Background"},
			// {from:"--white",to:"--minicart-2-sale-text-color",name:"Sale Text"},
			{ from: '--neutral-color-high-medium', to: '--minicart-2-f-border-color', name: 'Footer Border' },
			{ from: '--white', to: '--minicart-2-f-background-color', name: 'Footer Background' },
			{ from: '--text-color-1', to: '--minicart-2-subtotal-color', name: 'Subtotal Text' },
			{ from: '--text-color-1', to: '--minicart-2-total-color', name: 'Total Text' },
			{ from: '--text-color-1', to: '--minicart-2-disclaimer-color', name: 'Disclaimer Text' },
			{ from: '--neutral-color-high-light', to: '--minicart-2-freight-bg-color', name: 'Freight Background' },
			{ from: '--brand-color-primary-light', to: '--minicart-2-freight-slider-color', name: 'Freight Slider' },
			{ from: '--black', to: '--minicart-2-freight-text-color', name: 'Freight Text' },
			{ from: '--cta-color-pure', to: '--minicart-2-cta-bg-color', name: 'CTA Background' },
			{ from: '--cta-color-hover', to: '--minicart-2-cta-hover-color', name: 'CTA Hover Background' },
			{ from: '--cta-color-focus', to: '--minicart-2-cta-focus-color', name: 'CTA Focus Background' },
			{ from: '--text-color-1', to: '--minicart-2-cta-text-color', name: 'CTA Text' },
			{ from: '--brand-color-primary-pure', to: '--minicart-2-keep-buying-color', name: 'Keep Buying Text' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--minicart-2-qty-br', name: 'Product Quantity' },
			{ from: '--border-radius-none', to: '--minicart-2-btn-br', name: 'Freight/CTA' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-sm', to: '--minicart-2-qty-size', name: 'Product Quantity' },
			{ from: '--spacing-md', to: '--minicart-2-qty-btn-size', name: 'Product Quantity Btn' },
			{ from: '--spacing-sm', to: '--minicart-2-btn-size', name: 'CTA' },
			{ from: '--spacing-sm', to: '--minicart-2-ft-size', name: 'Freight' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-thin', to: '--minicart-2-qty-bw', name: 'Quantity' },
			{ from: '--border-width-hairline', to: '--minicart-2-footer-bw', name: 'Footer' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--minicart-2-header-fs', name: 'Header Text' },
			{ from: '--font-size-xs', to: '--minicart-2-pn-fs', name: 'Product Name' },
			{ from: '--font-size-xs', to: '--minicart-2-list-price-fs', name: 'Product List Price' },
			{ from: '--font-size-xs', to: '--minicart-2-price-fs', name: 'Product Price' },
			{ from: '--font-size-xs', to: '--minicart-2-quantity-fs', name: 'Product Quantity' },
			// {from:"--font-size-xs",to:"--minicart-2-sale-fs",name:"Sale"},
			{ from: '--font-size-xs', to: '--minicart-2-subtotal-fs', name: 'Subtotal' },
			{ from: '--font-size-xs', to: '--minicart-2-total-fs', name: 'Total' },
			{ from: '--font-size-xs', to: '--minicart-2-disclaimer-fs', name: 'Disclaimer' },
			{ from: '--font-size-xs', to: '--minicart-2-freight-fs', name: 'Freight' },
			{ from: '--font-size-xs', to: '--minicart-2-cta-fs', name: 'CTA' },
			{ from: '--font-size-xs', to: '--minicart-2-keep-buying-fs', name: 'Keep Buying' },
			{ from: '--font-size-xs', to: '--minicart-2-variation-fs', name: 'Variation' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--minicart-2-header-fw', name: 'Header Text' },
			{ from: '--font-weight-700', to: '--minicart-2-pn-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--minicart-2-list-price-fw', name: 'Product List Price' },
			{ from: '--font-weight-400', to: '--minicart-2-price-fw', name: 'Product Price' },
			{ from: '--font-weight-400', to: '--minicart-2-quantity-fw', name: 'Product Quantity' },
			// {from:"--font-weight-700",to:"--minicart-2-sale-fw",name:"Sale"},
			{ from: '--font-weight-400', to: '--minicart-2-subtotal-fw', name: 'Subtotal' },
			{ from: '--font-weight-700', to: '--minicart-2-total-fw', name: 'Total' },
			{ from: '--font-weight-700', to: '--minicart-2-disclaimer-fw', name: 'Disclaimer' },
			{ from: '--font-weight-400', to: '--minicart-2-freight-fw', name: 'Freight' },
			{ from: '--font-weight-700', to: '--minicart-2-cta-fw', name: 'CTA' },
			{ from: '--font-weight-700', to: '--minicart-2-keep-buying-fw', name: 'Keep Buying' },
			{ from: '--font-weight-400', to: '--minicart-2-variation-fw', name: 'Variation' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--minicart-2-header-ff', name: 'Header' },
			{ from: '--main-font', to: '--minicart-2-pn-ff', name: 'Product Name' },
			{ from: '--main-font', to: '--minicart-2-list-price-ff', name: 'Product List Price' },
			{ from: '--main-font', to: '--minicart-2-price-ff', name: 'Product Price' },
			// {from:"--main-font",to:"--minicart-2-sale-ff",name:"Sale"},
			{ from: '--main-font', to: '--minicart-2-quantity-ff', name: 'Product Quantity' },
			{ from: '--main-font', to: '--minicart-2-subtotal-ff', name: 'Subtotal' },
			{ from: '--main-font', to: '--minicart-2-total-ff', name: 'Total' },
			{ from: '--main-font', to: '--minicart-2-disclaimer-ff', name: 'Disclaimer' },
			{ from: '--main-font', to: '--minicart-2-freight-ff', name: 'Freight' },
			{ from: '--main-font', to: '--minicart-2-cta-ff', name: 'CTA' },
			{ from: '--main-font', to: '--minicart-2-keep-buying-ff', name: 'Keep Buying' },
			{ from: '--main-font', to: '--minicart-2-variation-ff', name: 'Variation' },
		],
	},
];
export default MinicartGroup;
